import { DialogBody, Spinner } from "@blueprintjs/core";
import React, { useState } from "react";

import { Button, Modal } from "../../../../components";
import { Play } from "../../../../types";
import { usePlaybookContext } from "../../playbook-context";
import styles from "./dialogs.module.scss";

interface RemovePlayDialogProps {
  show: boolean;
  handleClose: (e: any) => void;
  play: Play;
}

const RemovePlayDialog = ({ show, handleClose, play }: RemovePlayDialogProps) => {
  const [removingPlay, setRemovingPlay] = useState(false);
  const { removePlaysFromPlaybook } = usePlaybookContext();

  const handleRemovePlay = async () => {
    setRemovingPlay(true);
    await removePlaysFromPlaybook([play.id]);
    setRemovingPlay(false);
    handleClose(null);
  };

  return (
    <Modal
      title="Remove Play"
      isOpen={show}
      onClose={handleClose}
      actions={[
        <Button minimal={true} text="Cancel" onClick={handleClose} key={2} />,
        <Button intent="danger" onClick={handleRemovePlay} key={1}>
          {removingPlay ? <Spinner size={20} /> : "Delete"}
        </Button>,
      ]}
    >
      <DialogBody>
        <div>
          Are you sure you want to remove play <span className={styles.title}>{play.name}</span>?
        </div>
      </DialogBody>
    </Modal>
  );
};

export default RemovePlayDialog;
